import { Container, IconButton, Stack, Typography } from "@mui/material";
import ContactInformation from "./components/ContactInformation";
import PasswordInformation from "./components/PasswordInformation";
import AddressInformation from "./components/AddressInformation";
import { KeyboardBackspace } from "@mui/icons-material";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PatientAccount = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const page = "account.overview";
  const { t } = useTranslation();

  return (
    <Container maxWidth="xl" disableGutters>
      <Stack gap={isMobile ? 2 : 4}>
        <Stack direction="row" alignItems="center">
          {isMobile ? (
            <IconButton sx={{ color: "#00B6B8" }} onClick={() => navigate(-1)}>
              <KeyboardBackspace fontSize="large" />
            </IconButton>
          ) : null}
          <Typography variant="h5" fontWeight={700}>
            {t(`${page}.header`)}
          </Typography>
        </Stack>
        <ContactInformation page={page} />
        <AddressInformation page={page} />
        <PasswordInformation page={page} />
      </Stack>
    </Container>
  );
};

export default PatientAccount;
